import React from "react";
import { useTranslation } from "react-i18next";
import CoomingSoon from "../../CoomingSoon";

function ConsumerHome() {
    const { t } = useTranslation();
    return <CoomingSoon />
}

export default ConsumerHome;
